"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FieldDisplay = function FieldDisplay(props) {
  var question = props.question,
    hiddenFields = props.hiddenFields;
  if ((0, _lodash.indexOf)(hiddenFields, question.id) >= 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-form-renderer-question-display"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-form-renderer-question-display__label"
  }, question.label_text), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-form-renderer-question-display__value"
  }, (0, _utils.getQuestionDisplay)(question)));
};
FieldDisplay.propTypes = {
  question: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    input_type: _propTypes["default"].string,
    label_text: _propTypes["default"].string
  }).isRequired,
  hiddenFields: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = FieldDisplay;